import { HttpEvent } from '@angular/common/http';
import { UploadXHRArgs, UploadFile } from 'ng-zorro-antd';
import { NgxExcelSelectOption, NgxExcelUploadFile } from '../models/models';
import { Observable } from 'rxjs';

export interface NgxExcelUploadService {
  // getConfig: () => { url: string; name?: string; extraParams?: any };
  // resolve: (response: any) => NgxExcelUploadFile;
  getThumbUrl: (file: NgxExcelUploadFile) => string;
  getPreviewUrl: (file: NgxExcelUploadFile) => string;
  getDownloadUrl: (file: NgxExcelUploadFile) => string;
  upload: (uploadXHRArgs: UploadXHRArgs) => Observable<HttpEvent<{}>>;
  remove: (file: UploadFile) => Observable<NgxExcelUploadFile>;
}

export abstract class NgxExcelHelper {
  protected selectGroups: { [name: string]: NgxExcelSelectOption[] } = {};
  public getSelectOptions(name: string): NgxExcelSelectOption[] {
    return this.selectGroups[name] || [];
  }
  /**
   * å¤æ­æ¯å¦å·å¤è°ç¨æé
   * @param node å¾å¤æ­çæéèç¹
   * @param resourceId èµæºä¸»é®
   * @param extraRules æ©å±çèµæºè§å
   */
  public abstract can(node: string, resourceId?: string, extraRules?: any): boolean;
  /**
   * è·å¾æ°æ®ä¸ä¼ æå¡
   * @param payload é¢å¤çä¸ä¼ åæ°
   */
  public abstract getUploadService(payload: { [name: string]: string | Blob }): NgxExcelUploadService;
}
